// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CameraCameraActiveComponent} from './CameraCameraActive.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCameraCameraActive = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CameraCameraActiveComponent/>
  </Icon>
));
